import type { AnswerLogic } from '../../fetchSurvey/types/survey';
import type { LogicContext } from '../types';
import { evaluateCondition } from './evaluateCondition';

export function evaluateAnswerLogic(
  answerLogic: AnswerLogic | undefined,
  context: LogicContext
): boolean {
  if (!answerLogic) {
    return true;
  }

  return evaluateCondition(answerLogic.condition, context);
}
